// Functional Area enum values and labels
export const FUNCTIONAL_AREA_VALUES = ['P', 'A', 'G'] as const;
export type FunctionalAreaValue = typeof FUNCTIONAL_AREA_VALUES[number];

export const FUNCTIONAL_AREA_LABELS: Record<FunctionalAreaValue, string> = {
  P: 'Processo Produttivo',
  A: 'Servizi Ausiliari',
  G: 'Servizi Generali',
};

export const FUNCTIONAL_AREA_OPTIONS = FUNCTIONAL_AREA_VALUES.map(value => ({
  value,
  label: FUNCTIONAL_AREA_LABELS[value],
}));

// Helper function to get label from value
export const getFunctionalAreaLabel = (value: string | null | undefined): string => {
  if (!value) return '-';
  return FUNCTIONAL_AREA_LABELS[value as FunctionalAreaValue] || value;
};

// Helper function to convert label to enum value (case insensitive)
export const getFunctionalAreaValueFromLabel = (label: string | null | undefined): string | null => {
  if (!label) return null;
  const normalizedLabel = label.trim().toLowerCase();
  for (const [value, areaLabel] of Object.entries(FUNCTIONAL_AREA_LABELS)) {
    if (areaLabel.toLowerCase() === normalizedLabel) {
      return value;
    }
  }
  // Se non trova match, prova direttamente con i valori enum (P, A, G)
  if (FUNCTIONAL_AREA_VALUES.includes(normalizedLabel.toUpperCase() as FunctionalAreaValue)) {
    return normalizedLabel.toUpperCase();
  }
  return null;
};

